import React from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import api, { apiError } from "@/lib/api";
import { DashboardLayout } from "@/components/DashboardLayout";
import { Card } from "@/components/common";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { Power, ShieldQuestion } from "lucide-react";

export default function ProImpostazioni() {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["prof-profile"], queryFn: async () => (await api.get("/professional/profile")).data });
  const accepting = data?.profile?.accepting_requests ?? true;

  const toggle = async (v) => {
    try { await api.patch("/professional/accepting", { accepting_requests: v }); toast.success(v ? "Ricezione richieste attivata." : "Ricezione richieste in pausa."); qc.invalidateQueries({ queryKey: ["prof-profile"] }); }
    catch (e) { toast.error(apiError(e)); }
  };

  return (
    <DashboardLayout title="Impostazioni">
      <div className="max-w-2xl space-y-6">
        <Card>
          <div className="flex items-center justify-between">
            <div className="flex items-start gap-3">
              <span className="h-11 w-11 rounded-xl bg-[#E0EFEA] text-[#087A73] flex items-center justify-center"><Power className="h-5 w-5" /></span>
              <div>
                <p className="font-bold text-[#102A2A]">Ricezione nuove richieste</p>
                <p className="text-sm text-[#5C6B68]">Disattiva temporaneamente per non ricevere nuove richieste dai pazienti.</p>
              </div>
            </div>
            <Switch data-testid="accepting-toggle" checked={accepting} onCheckedChange={toggle} />
          </div>
        </Card>
        <Card className="space-y-2">
          <div className="flex items-center gap-2"><ShieldQuestion className="h-5 w-5 text-[#087A73]" /><h3 className="font-bold text-[#102A2A]">Responsabilità professionale</h3></div>
          <p className="text-sm text-[#5C6B68]">EtruriaCare è un intermediario tecnologico. La valutazione clinica, la prestazione, il trattamento e le decisioni professionali restano di tua esclusiva responsabilità come professionista sanitario.</p>
        </Card>
      </div>
    </DashboardLayout>
  );
}
